<template>
	<div class="MainBox">
    <div class="TableHead">
      <ul class="TableHeadLeft">
        <li @click="showAll" class="TableHeadLeftRow btnStyleTwo blueBackColor btnRadius"><span class="icon iconfont iconicon-test23"></span>显示全部</li>
      </ul>
      <ul class="TableHeadRight">
        <div class="SearchBox">
          <input placeholder="输入手机号查询" v-model="mobile" v-on:keyup.13="GetList(1)" />
          <a class="SearchBtn" @click="GetList(1)">搜索</a>
        </div>
        <div class="SearchBox" v-if="role == 10">
          <input placeholder="输入商户名称查询" v-model="name" v-on:keyup.13="GetList(1)" />
          <a class="SearchBtn" @click="GetList(1)">搜索</a>
        </div>
      </ul>
      <ul class="clear"></ul>
    </div>

    <div class="TableMain">
      <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!datas"></K-Transition>
      <table class="table StripeTable" v-else>
        <thead>
          <tr>
            <th v-if="role == 10">企业编号</th>
            <th v-if="role == 10">企业名称</th>
            <th>用户编号</th>
            <th>手机号</th>
            <th>用户名</th>
            <th>注册IP</th>
            <th>登录IP</th>
            <th>最近登录时间</th>
            <th>创建时间</th>
          </tr>
        </thead>
        <tbody class="TRHoverStyle">
          <tr v-for="(item,index) in datas" v-bind:key="index">
            <td v-if="role == 10" v-text="item.tenant_id"></td>
            <td v-if="role == 10" v-text="item.business && item.business.name"></td>
            <td v-text="item.id"></td>
            <td v-text="item.mobile"></td>
            <td v-text="item.nickname"></td>
            <td v-text="item.register_ip"></td>
            <td v-text="item.login_ip"></td>
            <td v-text="item.login_date"></td>
            <td v-text="item.create_time"></td>
          </tr>
        </tbody>
      </table>

      <!-- 分页器 -->
      <K-Paging :page="page" :totalPages="totalPages" @ChangePage="ChangePage" @SkipPage="SkipPage"></K-Paging>

    </div>

    <!-- 生码窗口 -->
    <div class="ModalBox" v-if="ModelShow">
      <div class="ModalMain">
        <div class="ModalMainHead">
          {{$t('b.CodeManage.CreateCodes')}}
          <span class="icon iconfont iconicon-test29 ModalMainHeadClose feedback" @click="HandleModel(false)"></span>
        </div>
        <div class="ModalMainBox">
          <ul class="FormStyleTwo">
            <li class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle">性别</p>
              <p>
               
              </p>
            </li>
            <li class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle"><i>*</i>{{$t('b.CodeManage.BarCodeNumber')}}</p>
              <p><input :placeholder="$t('b.CodeManage.HintThirteen')" maxlength="7" v-model="FormDatas.number" /></p>
            </li>
          </ul>
        </div>
        <div class="ModalMainFoot">
          <div class="ModalMainFootRight btnArray">
            <a class="btnStyleTwo btnRadius grayBackColor" @click="HandleModel(false)" v-text="$t('c.Common.Cancel')"></a>
            <a class="btnStyleTwo btnRadius blueBackColor" @click="SubmitForm" v-text="$t('c.Common.Confirm')"></a>
          </div>
        </div>
      </div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

	</div>
</template>

<script>
import axios from 'axios'
import Paging from '@/components/common/Paging.vue'
import Transition from '@/components/common/Transition.vue'
import Loading from '@/components/common/Loading.vue'
import Toast from '@/components/common/Toast.vue'
export default {
  name: 'AiMemberUser',
  components: {
    'K-Paging': Paging,
    'K-Transition': Transition,
    'K-Loading': Loading,
    'K-Toast': Toast
  },
  data () {
    return {
      role: 30,
      $self:null,
      page:1,
      subHint:'数据加载中...',
      isLoding:true,
      loading:false,
      Toast:{
        state: false,
        type: 0,
        txt: null
      },
      totalPages:1,
      datas:null,
      name: '',
      mobile: '',
      ModelShow:false,
      FormDatas:{},
      CodeNumber:null
    }
  },
  created () {
    this.role = localStorage.getItem("wwmxt_Role");
    axios.defaults.headers.common['token'] = localStorage.getItem("wwmxt_Token");
  },
  mounted () {
    this.GetList();
  },
  methods: {
    ToastFun (type,txt) {
      this.Toast.state = true;
      this.Toast.type = type;
      this.Toast.txt = txt;
    },
    ChangeToast () {
      this.Toast.state = false;
    },
    ChangePage (data) {  //上下翻页
      if(data.te == 1){
        if(this.page > 1){
          this.page--
        }
      }else{
        if(this.page < this.totalPages){
          this.page++
        }
      }
      this.GetList();
    },
    SkipPage (data) {  //跳转分页
      this.page = data.ix;
      this.GetList();
    },
    SelectData (ix,six) {  //选中选择框内容
      this.SelectArr[ix].ix = six;
      this.SelectArr[ix].isHover = false;
    },
    HandleModel (status) {  //隐藏显示生码模态框
      console.log(status)
      this.ModelShow = status;
    },
    showAll(){
      this.page = 1;
      this.mobile = '';
      this.name = '';
      this.GetList();
    },
    GetList (page) {
      if(page){
        this.page = page;
        this.totalPages = 0;
      }
      this.datas = null;
      this.isLoding = true;
      this.subHint = "数据加载中...";
      axios.get(this.GetServerUrl(1)+`ai_user_list/${this.page}?name=${this.name}&mobile=${this.mobile}`)
      .then( (response) => {
        this.datas = response.data.meta.data;
        this.isLoding = false;

        //总页数
        this.totalPages = response.data.meta.last_page;
      }).catch( (error) => {
        this.subHint = this.ErrorHint(error);
        this.isLoding = false;
      })
    },
    SubmitForm () {  //提交表单
      let datas = this.FormDatas;
      this.loading = true;
      axios({
        method:"post",
        url:this.GetServerUrl(1)+"ai_user",
        data:datas
      }).then( (response) => {
        this.GetList();

        this.ModelShow = false;
        this.loading = false;
        this.ToastFun(0,"编辑成功！");  //弹窗提醒

        //重置表单内容
        this.FormDatas.number = null;
      }).catch( (error) => {
        this.loading = false;
        this.ToastFun(2,this.ErrorHint(error));  //弹窗提醒
      })
    }
  }
}
</script>

<style scoped>
  .TableHeadRight{
    display: flex;
    gap: 20px;
  }
</style>
